var _style, _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgE3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M855.7,1000H144.3C64.9,1000,0,935.1,0,855.7V144.3C0,64.9,64.9,0,144.3,0h711.4C935.1,0,1000,64.9,1000,144.3 v711.4C1000,935.1,935.1,1000,855.7,1000z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 500,
    r: 192.86
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M500,950C251.87,950,50,748.13,50,500S251.87,50,500,50s450,201.87,450,450S748.13,950,500,950z M500,178.57 c-177.24,0-321.43,144.19-321.43,321.43S322.76,821.43,500,821.43S821.43,677.24,821.43,500S677.24,178.57,500,178.57z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgE3);
export default __webpack_public_path__ + "static/media/e3.03a4ed6e5b2a21666afa72b75f9a0e22.svg";
export { ForwardRef as ReactComponent };